import { Col, Input, Modal, Row, Select, Skeleton, Space, Tooltip } from "antd";
import React, { useContext, useEffect, useState } from "react";
import {
  Button,
  Paragraph,
  Title,
} from "Components/CommonComponents/GeneralComponents";
import "./index.css";
import PropTypes from "prop-types";
import { ToastContextDispatch } from "Context/CommonContext";
import {
  DislikeFilled,
  DislikeOutlined,
  InfoCircleOutlined,
  LikeFilled,
  LikeOutlined,
} from "@ant-design/icons";
import ReportLog from "./ReportLogo.svg";
import QuestionTextProvider from "Components/CommonComponents/QuestionTextProvider";
import QuestionSlider from "Pages/Questions/QuestionsHomeScreen/QuestionsSlider";
import {
  getAPIRequest,
  putPostRequest,
} from "utilFunctions/Axios/AxiosRequestConfiguration";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import { getAppendImgUrl } from "Pages/Questions/QuestionsHomeScreen/QuestionsTable";
import styled from "styled-components";
export const StyledMainDiv = styled("div")`
  margin-top: 16px;
  margin-right: ${({ screen }) =>
    ["xxl", "xl", "lg"].includes(screen) ? "16px" : "0px"};
  margin-left: ${({ screen }) =>
    ["xxl", "xl", "lg"].includes(screen)
      ? "xxl" === screen
        ? "44px"
        : "16px"
      : "0px"};
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
const hintOptions = [
  { label: "Point Hint", value: "pointHint" },
  { label: "Teach Hint", value: "teachHint" },
  { label: "Analogy Hint", value: "analogyHint" },
  { label: "Bottomout Hint", value: "bottomoutHint" },
  { label: "AI Generated Solution", value: "aiSolution" },
  { label: "Faculty Written Solution", value: "facultySolution" },
];
const hintsTooltipMsg = {
  pointHint:
    "Pointing hints mention problem conditions that should remind the student of the knowledge component’s relevance",
  teachHint:
    "Teaching hints describe the knowledge component briefly and show how to apply it",
  analogyHint:
    "Provide a relatable example or comparison to help the user understand the problem and the concept.",
  bottomoutHint: "Bottom-out hints tell the student the steps",
  aiSolution: "Solution is generated by an AI model.",
  facultySolution: "Solution is manually created by faculty members.",
};
const { TextArea } = Input;
const AIHintSliderMain = (props) => {
  const { question, closeQuesContentSlider, setRefresh, setUserVerifiedCount } =
    props;
  const ToastDispatch = useContext(ToastContextDispatch);
  const [questionContent, setQuestionContent] = useState(null);
  const [questionDetailsstate, setquestionDetailsstate] = useState({
    question: null,
    loading: false,
    error: null,
    qBP: {},
  });
  const [editIndex, setEditIndex] = useState([]);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [reportIssueModal, setReportIssueModal] = useState(null);
  const fetchQuestionDetails = async (question) => {
    let id = question.questionId;
    let url = BASE_URL + "bulkHint/view?questionId=" + id;
    setquestionDetailsstate({ question: null, loading: true, error: null });
    getAPIRequest({
      url,
      success: (response) => {
        const data = response?.data;
        if (data["data"]) {
          let newDataObj = {
            ...data["data"],
            questionId: id,
            questionStatus: data["data"]["status"],
          };

          let qBP = {};
          hintOptions.map(
            (el) =>
              (qBP[`${el.value}`] =
                el.value == "aiSolution"
                  ? data["data"][`${el.value}`]
                  : data["data"][`${el.value}Ai`])
          );
          setquestionDetailsstate((prevQuestionDetailsState) => ({
            question: {
              ...prevQuestionDetailsState.question,
              ...newDataObj,
            },
            qBP: {
              ...prevQuestionDetailsState.qBP,
              ...qBP,
            },
            loading: false,
            error: null,
          }));
        }
      },
      failure: (data) => {
        if (data["code"] == "429") {
          setquestionDetailsstate({
            question: null,
            loading: false,
            error: null,
          });
        } else {
          ToastDispatch({
            isOpen: true,
            type: "Error",
            message:
              "AI Generated Hint and Solution Not found for this question",
          });
          setquestionDetailsstate({
            question: null,
            loading: false,
            error: null,
          });
        }
      },
    });
  };
  const fetchQuestionContent = async (question) => {
    let id = question.questionId;
    let url = BASE_URL + "questionLanguage?questionId=" + id;
    getAPIRequest({
      url,
      success: (response) => {
        const data = response?.data;
        setQuestionContent(data["data"] || [{ language: "en" }]);
        setquestionDetailsstate((prevQuestionDetailsState) => ({
          question: {
            ...prevQuestionDetailsState.question,
            facultySolution: data["data"][0]["solution"],
          },
          qBP: {
            ...prevQuestionDetailsState.qBP,
            facultySolution: data["data"][0]["solution"],
          },
          loading: false,
          error: null,
        }));
      },
      failure: (data) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: data["message"] || data["msg"],
        });
      },
    });
  };
  useEffect(() => {
    fetchQuestionDetails(question);
    fetchQuestionContent(question);
  }, [question]);

  const handleAiFeedback = (name, value) => {
    let newQuestionCopy = { ...questionDetailsstate?.question };
    newQuestionCopy[`${name}Feedback`] = value;
    setquestionDetailsstate((prevquestionDetailsstate) => ({
      ...prevquestionDetailsstate,
      question: { ...prevquestionDetailsstate.question, ...newQuestionCopy },
    }));
  };
  const handleEditFeedback = (name) => {
    if (editIndex.includes(name)) {
      let newEditArray = editIndex.filter((item) => item != name);
      setEditIndex([newEditArray]);
    } else {
      setEditIndex((prev) => [...prev, name]);
    }
  };
  const handleEditedFeedback = (name, e) => {
    let newQuestionCopy = { ...questionDetailsstate?.question };
    if (name.includes("Solution")) {
      newQuestionCopy[`${name}`] = e.target.value;
      newQuestionCopy[`${name}User`] = e.target.value;
    } else {
      newQuestionCopy[`${name}Ai`] = e.target.value;
      newQuestionCopy[`${name}User`] = e.target.value;
    }
    setquestionDetailsstate((prevquestionDetailsstate) => ({
      ...prevquestionDetailsstate,
      question: { ...prevquestionDetailsstate.question, ...newQuestionCopy },
    }));
  };
  const handleResetFeedback = (name) => {
    let newQuestionCopy = { ...questionDetailsstate?.question };
    if (name.includes("Solution")) {
      newQuestionCopy[`${name}`] = questionDetailsstate?.qBP[`${name}`];
      delete newQuestionCopy[`${name}User`];
    } else {
      newQuestionCopy[`${name}Ai`] = questionDetailsstate?.qBP[`${name}`];
      delete newQuestionCopy[`${name}User`];
    }

    setquestionDetailsstate((prevquestionDetailsstate) => ({
      ...prevquestionDetailsstate,
      question: { ...newQuestionCopy },
    }));
  };
  const handleSaveFeedback = (questionDetailsstate, isReported) => {
    let newObj = {
      questionId: question.questionId,
      hintGenerationId: questionDetailsstate?.question?.generationId,
      pointHintUser: isReported
        ? null
        : questionDetailsstate?.question?.pointHintUser ?? null,
      teachHintUser: isReported
        ? null
        : questionDetailsstate?.question?.teachHintUser ?? null,
      analogyHintUser: isReported
        ? null
        : questionDetailsstate?.question?.analogyHintUser ?? null,
      bottomoutHintUser: isReported
        ? null
        : questionDetailsstate?.question?.bottomoutHintUser ?? null,
      aiSolutionUser: isReported
        ? null
        : questionDetailsstate?.question?.aiSolutionUser ?? null,
      pointHintFeedback: isReported
        ? false
        : questionDetailsstate?.question?.pointHintFeedback,
      teachHintFeedback: isReported
        ? false
        : questionDetailsstate?.question?.teachHintFeedback,
      analogyHintFeedback: isReported
        ? false
        : questionDetailsstate?.question?.analogyHintFeedback,
      bottomoutHintFeedback: isReported
        ? false
        : questionDetailsstate?.question?.bottomoutHintFeedback,
      aiSolutionFeedback: isReported
        ? false
        : questionDetailsstate?.question?.aiSolutionFeedback,
      facultySolutionFeedback: isReported
        ? false
        : questionDetailsstate?.question?.facultySolutionFeedback,
      facultySolutionUser: isReported
        ? null
        : questionDetailsstate?.question?.facultySolutionUser ?? null,
    };
    if (isReported) {
      newObj["questionReporting"] = selectedIssue;
    }
    putPostRequest({
      url: BASE_URL + "bulkHint/saveFeedback",
      success: (data) => {
        setTimeout(() => {
          setRefresh(new Date().getMilliseconds());
          if (isReported) {
            handleReport();
            closeQuesContentSlider();
            setSelectedIssue(null);
          }
          setEditIndex([]);
          setUserVerifiedCount(
            (prevUserVerifiedCount) => parseInt(prevUserVerifiedCount) + 1
          );
          ToastDispatch({
            isOpen: true,
            type: "Success",
            message: data["message"] || "Success",
          });
        }, 1000);
      },
      failure: (err) => {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message:
            err?.response?.data?.code == "400"
              ? err?.response?.data?.message
              : "Something went wrong",
        });
      },
      body: newObj,
      method: "Post",
    });
  };
  const handleResetAllFeedback = () => {
    closeQuesContentSlider();
    setquestionDetailsstate({
      question: null,
      loading: false,
      error: null,
      qBP: {},
    });
  };
  const returnTooltipMsg = (type) => {
    return hintsTooltipMsg[type];
  };

  const handleReport = () => {
    setReportIssueModal(!reportIssueModal);
  };
  const handleChange = (e) => {
    setSelectedIssue(e);
  };
  const saveReportQuestion = (quesDetailsState) => {
    handleSaveFeedback(quesDetailsState, true);
  };
  console.log(questionContent, "questionContent", questionDetailsstate);
  return (
    <>
      <Modal
        title={"Report This Question"}
        keyboard={false}
        backdrop="static"
        open={reportIssueModal}
        onCancel={() => handleReport()}
        centered={true}
        width={445}
        footer={false}
      >
        <div className="d-flex flex-column align-items-start justify-content-start w-100">
          <Select
            value={selectedIssue}
            style={{
              width: 400,
            }}
            placeholder="Select reason"
            onChange={(e) => handleChange(e, questionDetailsstate)}
            options={[
              {
                label: "Incorrect question",
                value: "Incorrect question",
              },
              {
                label: "Incorrect answer",
                value: "Incorrect answer",
              },
            ]}
          />
          <Space
            style={{
              marginTop: "24px",
            }}
          >
            <Button type="default" onClick={() => handleReport()}>
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={selectedIssue != null ? false : true}
              onClick={() => {
                saveReportQuestion(questionDetailsstate);
              }}
            >
              Save
            </Button>
          </Space>
        </div>
      </Modal>
      <QuestionSlider
        mode="AIHint"
        question={question}
        closeQuesContentSlider={closeQuesContentSlider}
      />
      {!questionDetailsstate.loading ? (
        questionDetailsstate.question != null ? (
          <Row>
            <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
              <Title level={5}>Hint :</Title>
            </div>
            {hintOptions.map((el, index) => {
              return !el.value.includes("Solution") ? (
                <Col span={24}>
                  <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
                    <Tooltip title={() => returnTooltipMsg(el.value)}>
                      <Space>
                        <Title level={5} className="hintTitleIndex">
                          {index + 1}. {el.label}
                        </Title>
                        <InfoCircleOutlined className="tableIdIconstyle" />
                      </Space>
                    </Tooltip>
                    {editIndex.includes(el.value)
                      ? questionDetailsstate.question &&
                        questionDetailsstate.question !== undefined && (
                          <TextArea
                            className="marginBottomAIHINT"
                            autoSize={{ minRows: 2, maxRows: 6 }}
                            //   defaultValue={questionDetailsstate.question[`${el.value}Ai`]}
                            value={
                              questionDetailsstate.question[`${el.value}Ai`]
                            }
                            onChange={(e) => handleEditedFeedback(el.value, e)}
                          >
                            {" "}
                          </TextArea>
                        )
                      : questionDetailsstate.question &&
                        questionDetailsstate.question !== undefined && (
                          <Paragraph className="marginBottomAIHINT">
                            {questionDetailsstate.question[`${el.value}User`] !=
                              undefined &&
                            questionDetailsstate.question[`${el.value}User`] !=
                              null
                              ? questionDetailsstate.question[`${el.value}User`]
                              : questionDetailsstate.question[
                                  `${el.value}Ai`
                                ]}{" "}
                          </Paragraph>
                        )}
                    <Space>
                      {questionDetailsstate.question[`${el.value}Feedback`] !=
                        undefined &&
                      questionDetailsstate.question[`${el.value}Feedback`] !=
                        null &&
                      questionDetailsstate.question[`${el.value}Feedback`] ? (
                        <LikeFilled
                          style={{
                            fontSize: "16px",
                            color: "green",
                          }}
                        />
                      ) : (
                        <LikeOutlined
                          onClick={() => {
                            question.tags != null &&
                              !question.tags.split(",").includes("HV") &&
                              handleAiFeedback(el.value, true);
                          }}
                          style={{
                            fontSize: "16px",
                            color:
                              questionDetailsstate.question[
                                `${el.value}Feedback`
                              ] == null
                                ? "black"
                                : "gray",
                          }}
                        />
                      )}
                      {questionDetailsstate.question[`${el.value}Feedback`] !=
                        undefined &&
                      questionDetailsstate.question[`${el.value}Feedback`] !=
                        null &&
                      !questionDetailsstate.question[`${el.value}Feedback`] ? (
                        <DislikeFilled
                          style={{
                            fontSize: "16px",
                            color: "red",
                            marginLeft: "15px",
                          }}
                        />
                      ) : (
                        <DislikeOutlined
                          onClick={() => {
                            question.tags != null &&
                              !question.tags.split(",").includes("HV") &&
                              handleAiFeedback(el.value, false);
                          }}
                          style={{
                            fontSize: "16px",
                            color:
                              questionDetailsstate.question[
                                `${el.value}Feedback`
                              ] == null
                                ? "black"
                                : "gray",
                            marginLeft: "15px",
                          }}
                        />
                      )}
                      {question.tags != null &&
                      !question.tags.split(",").includes("HV") ? (
                        <Space>
                          <Button
                            type="text"
                            style={{
                              color: editIndex.includes(el.value)
                                ? "#000000E0"
                                : "#008dc4",
                            }}
                            onClick={() => {
                              handleEditFeedback(el.value, index);
                            }}
                          >
                            {editIndex.includes(el.value) ? "Close" : "Edit"}
                          </Button>
                          {editIndex.includes(el.value) && (
                            <Button
                              type="text"
                              onClick={() => {
                                handleResetFeedback(el.value, index);
                              }}
                            >
                              Reset
                            </Button>
                          )}
                        </Space>
                      ) : null}
                    </Space>
                  </div>
                </Col>
              ) : null;
            })}
            <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
              <Title level={5}>Solution :</Title>
            </div>
            {hintOptions.map((el, index) => {
              return el.value.includes("Solution") ? (
                <Col span={24}>
                  <div className="d-flex flex-column mb-3 justify-content-start align-items-start">
                    <Tooltip title={() => returnTooltipMsg(el.value)}>
                      <Space>
                        <Title level={5} className="hintTitleIndex">
                          {el.label}
                        </Title>
                        <InfoCircleOutlined className="tableIdIconstyle" />
                      </Space>
                    </Tooltip>
                    {editIndex.includes(el.value)
                      ? questionDetailsstate.question &&
                        questionDetailsstate.question !== undefined && (
                          <TextArea
                            className="marginBottomAIHINT"
                            autoSize={{ minRows: 2, maxRows: 6 }}
                            //   defaultValue={questionDetailsstate.question[`${el.value}Ai`]}
                            value={
                              questionDetailsstate.question[`${el.value}`]
                                ? questionDetailsstate.question[`${el.value}`]
                                : ""
                            }
                            onChange={(e) => handleEditedFeedback(el.value, e)}
                          >
                            {" "}
                          </TextArea>
                          //   <RickQuestionComponent
                          //     required={true}
                          //     name={el.value}
                          //     triggerFunction={(data) => {
                          //       handleEditedFeedback(el.value, data);
                          //       //   onClickHandler(name, data);
                          //     }}
                          //     defaultValue={
                          //       questionDetailsstate.question[`${el.value}`]
                          //         ? questionDetailsstate.question[`${el.value}`]
                          //         : ""
                          //     }
                          //     handleCommentClick={() => {}}
                          //     title={el.label}
                          //     controlName={"normalize"}
                          //     onBtnClick={() => {
                          //       //   setIsContentEdit(false);
                          //       handleEditFeedback(el.value, index);
                          //       //   onClickHandler(name, content);
                          //     }}
                          //   />
                        )
                      : questionDetailsstate.question &&
                        questionDetailsstate.question !== undefined && (
                          <QuestionTextProvider
                            className="marginBottomAIHINT"
                            content={getAppendImgUrl(
                              questionDetailsstate.question[
                                `${el.value}User`
                              ] != undefined &&
                                questionDetailsstate.question[
                                  `${el.value}User`
                                ] != null
                                ? questionDetailsstate.question[
                                    `${el.value}User`
                                  ]
                                : questionDetailsstate.question[`${el.value}`]
                            )}
                          />
                        )}
                    <Space>
                      {questionDetailsstate.question[`${el.value}Feedback`] !=
                        undefined &&
                      questionDetailsstate.question[`${el.value}Feedback`] !=
                        null &&
                      questionDetailsstate.question[`${el.value}Feedback`] ? (
                        <LikeFilled
                          style={{
                            fontSize: "16px",
                            color: "green",
                          }}
                        />
                      ) : (
                        <LikeOutlined
                          onClick={() => {
                            question.tags != null &&
                              !question.tags.split(",").includes("HV") &&
                              handleAiFeedback(el.value, true);
                          }}
                          style={{
                            fontSize: "16px",
                            color:
                              questionDetailsstate.question[
                                `${el.value}Feedback`
                              ] == null
                                ? "black"
                                : "gray",
                          }}
                        />
                      )}
                      {questionDetailsstate.question[`${el.value}Feedback`] !=
                        undefined &&
                      questionDetailsstate.question[`${el.value}Feedback`] !=
                        null &&
                      !questionDetailsstate.question[`${el.value}Feedback`] ? (
                        <DislikeFilled
                          style={{
                            fontSize: "16px",
                            color: "red",
                            marginLeft: "15px",
                          }}
                        />
                      ) : (
                        <DislikeOutlined
                          onClick={() => {
                            question.tags != null &&
                              !question.tags.split(",").includes("HV") &&
                              handleAiFeedback(el.value, false);
                          }}
                          style={{
                            fontSize: "16px",
                            color:
                              questionDetailsstate.question[
                                `${el.value}Feedback`
                              ] == null
                                ? "black"
                                : "gray",
                            marginLeft: "15px",
                          }}
                        />
                      )}
                      {question.tags != null &&
                      !question.tags.split(",").includes("HV") ? (
                        <Space>
                          <Button
                            type="text"
                            style={{
                              color: editIndex.includes(el.value)
                                ? "#000000E0"
                                : "#008dc4",
                            }}
                            onClick={() => {
                              handleEditFeedback(el.value, index);
                            }}
                          >
                            {editIndex.includes(el.value) ? "Close" : "Edit"}
                          </Button>
                          {editIndex.includes(el.value) && (
                            <Button
                              type="text"
                              onClick={() => {
                                handleResetFeedback(el.value, index);
                              }}
                            >
                              Reset
                            </Button>
                          )}
                        </Space>
                      ) : null}
                    </Space>
                  </div>
                </Col>
              ) : null;
            })}
            {question.tags != null &&
            !question.tags.split(",").includes("HV") ? (
              <Col
                span={24}
                className="d-flex flex-row justify-content-between"
              >
                <Space size={"large"}>
                  <Button
                    type="default"
                    onClick={() => {
                      handleResetAllFeedback(questionDetailsstate);
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => {
                      handleSaveFeedback(questionDetailsstate);
                    }}
                  >
                    Save
                  </Button>
                </Space>
                <div
                  className="d-flex flex-row align-items-center border rounded p-1 pl-2 pr-2"
                  style={{
                    borderColor: "#d9d9d9",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleReport();
                  }}
                >
                  <img src={ReportLog} />
                  <span style={{ color: "#333333", marginLeft: "8px" }}>
                    {" Report Question"}
                  </span>
                </div>
              </Col>
            ) : null}
          </Row>
        ) : (
          <></>
        )
      ) : (
        <>
          <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
          <br />
          <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
          <br />
          <Skeleton active paragraph={{ rows: 2 }}></Skeleton>
        </>
      )}
    </>
  );
};

AIHintSliderMain.propTypes = {
  question: PropTypes.object,
  closeQuesContentSlider: PropTypes.any,
  setRefresh: PropTypes.func,
  setUserVerifiedCount: PropTypes.func,
};

export default AIHintSliderMain;
